var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.053 3.421h8.777a3.632 3.632 0 0 1 3.632 3.633V22.49a3.63 3.63 0 0 1-1.886 3.184l-2.92-2.92-1.284 1.285 2.082 2.08h-8.4A3.632 3.632 0 0 1 8.42 22.49V7.052a3.632 3.632 0 0 1 3.633-3.632zM22.61 28.277a6.05 6.05 0 0 1-1.78.266h-8.777A6.053 6.053 0 0 1 6 22.49V7.052A6.053 6.053 0 0 1 12.053 1h8.777a6.053 6.053 0 0 1 6.053 6.053V22.49a6.046 6.046 0 0 1-2.553 4.938l2.288 2.288L25.333 31l-2.723-2.724z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQash);
export default __webpack_public_path__ + "static/media/QASH.1725f5388dff0b40b997af4bc5c23836.svg";
export { ForwardRef as ReactComponent };